const appInfo = {
    title: 'SBR graphmy'
};
export default appInfo;

